import { createSelector } from 'reselect';

export const selectIrisPromotionalBannerData = (state) => state?.irisPromotionalBannerData || {};

export const selectShippingThresholds = createSelector(
    selectIrisPromotionalBannerData,
    (irisPromotionalBannerData) => irisPromotionalBannerData?.shippingThresholds || {}
);

export const selectRewardCustomerThreshold = createSelector(
    selectShippingThresholds,
    (shippingThresholds) => shippingThresholds?.rewardCustomer || ''
);

export const selectCreditCustomerThreshold = createSelector(
    selectShippingThresholds,
    (shippingThresholds) => shippingThresholds?.creditCustomer || ''
);
